// Header.js
import React from 'react';

function Header() {
    return (
        <header className='header'>
            <h1>Snake Game</h1>
            <p>Use the arrow keys to move the snake</p>
        </header>
    );
}

export default Header;